module.exports = __webpack_public_path__ + "b3c22b835e54cfec83d44b66b0066850.pdf";